// extracted by mini-css-extract-plugin
module.exports = {"content":"ApplicationContainer__content__3cM8Z"};